<template>
  <div>
    <loginComponent></loginComponent>
  </div>
</template>

<script>
  import { getDifferentSiteNameInList } from '@/common/js/siteUtil.js'
  const differentSiteList = ['betl', 'b027site', 'b027sport']
  const siteName = getDifferentSiteNameInList(differentSiteList)
  const loginComponent = () => import(`@/components/different/${siteName}/loginbox/loginbox.vue`)
  export default {
    components: {
      loginComponent
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
  .loginbox_w
    background-color #fff
    height 1.4rem
    padding 0 0.28rem
    display flex
    align-items center
    .btn_l_w
      width 100%
      box-sizing border-box
      font-size 0.28rem
      display flex
      justify-content space-between
      color #fff
      .btn_d
        height 0.6rem
        width 1.5rem
        display flex
        align-items center
        justify-content center
        border-radius 0.1rem
        background-color #959595
        &.bule
          background-color #3385ff
        &.gree
          background-color #167e5d
    .in_box
      width 100%
      font-size 0.28rem
      .in_top
        .line_s
          text-decoration underline
          color #cd3c29
        .blue
          color $blue
          .red
            color #cd3c29
      .in_bottom
        color $blue
        margin-top 0.34rem
        display flex
        align-items center
        justify-content space-between
</style>



// WEBPACK FOOTER //
// src/components/common/loginbox/loginbox.vue